export class TransactionAPIModel  {
  TransactionAPI: string = "";
  TransactioDetailsAPI: string = "";
  StartAPI: string = "";
  UpdateNotes: string = "";
  UploadTransactionFile: string = "";
  DownloadTransactionFile: string = "";
  UpdateTransactionAPI: string = "";
  VolumeIssueListAPI: string = "";
  GetJournalList: string = "";
  FailedMsg: string = "";
  SelectFileErrorMsg: string = "";
  UploadFileMsg: string = "";
}
